import { Component, Input } from '@angular/core'
import { IDataCardNotification } from '../../../../../models/data-card.model'

@Component({
    selector: 'app-notification-data-card-items',
    templateUrl: './notification-data-card-items.component.html',
    styles: [
        `
      .large-tooltip .tooltip-inner {
        background-color: #000000;
        min-width: 260px;
      }
      .table thead th,
      .table tbody td {
        font-size: 12px;
        padding: 5px 10px;
        border: 0;
      }
      .table tbody tr td {
        vertical-align: top;
      }
    `,
    ],
    standalone: false
})
export class NotificationDataCardItemsComponent {
  @Input() notifications: IDataCardNotification[] = []
  @Input() isLoading: boolean = false
}
